import { ProfileEntity } from '../profile/profile-entity';

export class ChatRoom {
  public roomId: string;
  public participants: ProfileEntity[];
}
